// src/router.tsx
import { createBrowserRouter, Navigate } from 'react-router-dom';
import LoginPage from '@/pages/auth/LoginPage';
// import SignupPage from '@/pages/auth/SignupPage';
import SignupWithPlansPage from '@/pages/auth/SignupWithPlansPage';
import PasswordResetPage from '@/pages/auth/PasswordResetPage';
import AppPasswordResetGate from '@/pages/auth/AppPasswordResetGate';
import UpdatePasswordPage from '@/pages/auth/UpdatePasswordPage';
import CallbackPage from '@/pages/auth/CallbackPage';
import ProtectedRoute from '@/components/auth/ProtectedRoute';
import ProtectedPartnerRoute from '@/components/auth/ProtectedPartnerRoute';
import AdminRoute from '@/components/auth/AdminRoute';
import ProtectedDashboardLayout from '@/components/layouts/ProtectedDashboardLayout';
import PartnerLayout from '@/components/layouts/PartnerLayout';
import AdminLayout from '@/components/layouts/AdminLayout';

// Import Dashboard pages
import DashboardPage from '@/pages/dashboard/DashboardPage';
import CallsPage from '@/pages/dashboard/CallsPage';
import CallQueuePage from '@/pages/dashboard/CallQueuePage';
import ReceptionistSettingsPage from '@/pages/dashboard/ReceptionistSettingsPage';
import IntegrationsPage from '@/pages/dashboard/IntegrationsPage';
import AccountPage from '@/pages/dashboard/AccountPage';
import ResourcesPage from '@/pages/dashboard/ResourcesPage';
import HeroCommands from '@/pages/dashboard/HeroCommandsPage';
import BillingPage from '@/pages/dashboard/BillingPage';
import EmailsPage from '@/pages/dashboard/EmailsPage';
// Import NEW Onboarding Page
import OnboardingPage from '@/pages/onboarding/OnboardingPage';
import PartnerDashboard from '@/pages/partner/PartnerDashboard';
import StripeCallback from '@/pages/partner/StripeCallback';
import BillingSuccessPage from '@/pages/billing/BillingSuccessPage';
import BillingCancelPage from '@/pages/billing/BillingCancelPage';
import PreviewPage from '@/pages/PreviewPage';
// Import Admin pages
import TutorialsManager from '@/pages/admin/TutorialsManager';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <ProtectedRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard/dashboard" replace />,
      },
      {
        path: 'onboarding', 
        element: <OnboardingPage />, 
      },
      {
        path: 'dashboard',
        element: <ProtectedDashboardLayout />, 
        children: [
          {
            index: true,
            element: <Navigate to="/dashboard/dashboard" replace />,
          },
          { path: 'dashboard', element: <DashboardPage /> },
          { path: 'call-queue', element: <CallQueuePage /> },
          { path: 'calls', element: <CallsPage /> },
          { path: 'emails', element: <EmailsPage /> },
          { path: 'receptionist-settings', element: <ReceptionistSettingsPage /> },
          { path: 'integrations', element: <IntegrationsPage /> },
          { path: 'hero-commands', element: <HeroCommands /> },
          { path: 'account', element: <AccountPage /> },
          { path: 'billing', element: <BillingPage /> },
          { path: 'resources', element: <ResourcesPage /> },
          { path: 'partner', element: <Navigate to="/partner/dashboard" replace /> },
        ],
      },
      {
        path: 'partner',
        element: <PartnerLayout />,
        children: [
          {
            index: true,
            element: <Navigate to="/partner/dashboard" replace />,
          },
          {
            path: 'dashboard',
            element: <PartnerDashboard />,
          },
          {
            path: 'sub-accounts', 
            element: <PartnerDashboard />,
          },
          {
            path: 'commissions',
            element: <PartnerDashboard />,
          },
          {
            path: 'payouts',
            element: <PartnerDashboard />,
          },
          {
            path: 'domains',
            element: (
              <ProtectedPartnerRoute requireWhiteLabel={true}>
                <PartnerDashboard />
              </ProtectedPartnerRoute>
            ),
          },
          {
            path: 'pricing',
            element: <PartnerDashboard />,
          },
          {
            path: 'branding',
            element: (
              <ProtectedPartnerRoute requireWhiteLabel={true}>
                <PartnerDashboard />
              </ProtectedPartnerRoute>
            ),
          },
          {
            path: 'help-center',
            element: (
              <ProtectedPartnerRoute requireWhiteLabel={true}>
                <PartnerDashboard />
              </ProtectedPartnerRoute>
            ),
          },
          {
            path: 'tutorials',
            element: <PartnerDashboard />,
          },
          {
            path: 'settings',
            element: <PartnerDashboard />,
          },
        ],
      },
    ],
  },
  { path: '/login', element: <LoginPage /> },
  // { path: '/signup', element: <SignupPage /> },
  { path: '/affiliate/signup', element: <SignupWithPlansPage /> },
  { path: '/password-reset', element: <PasswordResetPage /> },
  { path: '/password-reset/gate', element: <AppPasswordResetGate /> },
  { path: '/update-password', element: <UpdatePasswordPage /> },
  { path: '/auth/callback', element: <CallbackPage /> },
  { path: '/partner/stripe-callback', element: <StripeCallback /> },
  { path: '/preview', element: <PreviewPage /> },

  { path: '/billing/success', element: <BillingSuccessPage /> },
  { path: '/billing/cancel', element: <BillingCancelPage /> },

  { path: '/preview', element: <PreviewPage /> },

  // Admin routes - protected by AdminRoute with AdminLayout
  {
    path: '/admin',
    element: <AdminRoute />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          { path: 'tutorials', element: <TutorialsManager /> },
        ],
      },
    ],
  },

  {
      path: '*',
      element: <Navigate to="/login" replace />,
  }
]);